let categoriesByTypeList = null;
// categories names and coordinates by groupId
export const subcategoryGroupsNames = {
  'g-1-1': 'De cabeza',
  'g-1-2': 'Dentro del área',
  'g-1-3': 'Penal',
  'g-1-4': 'Tiro libre',
  'g-1-5': 'Fuera del área',
  'g-2-1': '1/4 de cancha',
  'g-2-2': '2/4 de cancha',
  'g-2-3': '3/4 de cancha',
  'g-2-4': '4/4 de cancha',
  'g-3-1': 'Por izquierda',
  'g-3-2': 'Por derecha',
  'g-3-1-1': 'Comba hacía afuera',
  'g-3-1-2': 'Comba hacía adentro',
  'g-3-1-3': 'Tocado en corto',
  'g-3-1-4': 'Razo al área',
  'g-3-1-1-1': 'Rematado a destino',
  'g-3-1-1-2': 'Rematado sin destino',
  'g-3-1-1-3': 'Ganados por el portero rival',
  'g-3-1-1-4': 'Ganados por el rival',
  'g-3-1-1-5': 'Sin destino',
  'g-3-1-1-1-1': 'Fue gol',
  'g-3-1-1-1-2': 'No fue gol',
  'g-25-1': 'Por izquierda',
  'g-25-2': 'Por derecha',
  'g-25-1-1': 'Rematados con cabeza',
  'g-25-1-2': 'Rematados con pie',
  'g-25-1-3': 'Recentrados',
  'g-25-1-4': 'Retenido',
  'g-25-1-5': 'Ganados por portero',
  'g-25-1-6': 'Ganados por jugador',
  'g-25-1-7': 'Sin destino',
  'g-25-1-1-1': 'Destino a portería',
  'g-25-1-1-2': 'Sin destino a portería',
  'g-25-1-1-1-1': 'Fue gol',
  'g-25-1-1-1-2': 'No fue gol',
  'g-4-1': 'En disputa',
  'g-4-2': 'Sin disputa',
  'g-4-1-1': '1/4 de cancha',
  'g-4-1-2': '2/4 de cancha',
  'g-4-1-3': '3/4 de cancha',
  'g-4-1-4': '4/4 de cancha',
  'g-7-1': 'Pie izquierdo',
  'g-7-2': 'Pie derecho',
  'g-7-1-1': 'Fuera del área',
  'g-7-1-2': 'Dentro del área',
  'g-7-1-1-1': 'Destino a portería',
  'g-7-1-1-2': 'Desviados',
  'g-7-1-1-3': 'Bloqueado',
  'g-7-1-1-1-1': 'Fue gol',
  'g-7-1-1-1-2': 'No fue gol',
  'g-8-1': 'Por izquierda',
  'g-8-2': 'Por derecha',
  'g-8-1-1': 'Rematados con cabeza',
  'g-8-1-2': 'Rematados con pie',
  'g-8-1-3': 'Recentrados',
  'g-8-1-4': 'Retenido',
  'g-8-1-5': 'Ganados por el portero rival',
  'g-8-1-6': 'Ganados por el rival',
  'g-8-1-7': 'Sin destino',
  'g-8-1-1-1': 'Destino a portería',
  'g-8-1-1-2': 'Sin destino a portería',
  'g-8-1-1-1-1': 'Fue gol',
  'g-8-1-1-1-2': 'No fue gol',
  'g-24-1': 'Pie izquierdo',
  'g-24-2': 'Pie derecho',
  'g-24-1-1': 'Fuera del área',
  'g-24-1-2': 'Dentro del área',
  'g-24-1-1-1': 'Destino a portería',
  'g-24-1-1-2': 'Desviado',
  'g-24-1-1-3': 'Bloqueado',
  'g-24-1-1-1-1': 'Fue gol',
  'g-24-1-1-1-2': 'No fue gol',
  'g-13-1': 'Proveniente de centro por izquierda',
  'g-13-2': 'Proveniente de corner por izquierda',
  'g-13-3': 'Proveniente de centro por derecha',
  'g-13-4': 'Proveniente de corner por derecha',
  'g-13-5': 'Otros',
  'g-13-6': 'Proveniente de tiro libre',
  'g-13-1-1': 'Con cabeza',
  'g-13-1-2': 'Con pie',
  'g-13-1-1-1': 'Sacó del área',
  'g-13-1-1-2': 'No sacó del área',
  'g-13-1-1-1-1': 'A tiro de esquina',
  'g-13-1-1-1-2': 'A la izquierda',
  'g-13-1-1-1-3': 'Al centro',
  'g-13-1-1-1-4': 'A la derecha',
  'g-14-1': 'Con cabeza',
  'g-14-2': 'Con pie',
  'g-14-1-1': 'Proveniente de centro',
  'g-14-1-2': 'Proveniente de corner',
  'g-14-1-3': 'Otros',
  // *
  'g-14-1-4': 'Proveniente de tiro libre',
  'g-14-1-1-1': 'Con destino a portería',
  'g-14-1-1-2': 'Sin destino a portería',
  'g-14-1-1-3': 'Tocado',
  'g-14-1-1-4': 'Retenido',
  'g-14-1-1-1-1': 'Fue gol',
  'g-14-1-1-1-2': 'No fue gol',
  // *
  'g-15-1': '1/4 de cancha',
  'g-15-2': '2/4 de cancha',
  'g-15-3': 'Cancha rival',
  'g-15-4': 'Penal cometido',
  'g-16-1': 'Cancha propia',
  'g-16-2': '3/4 de cancha',
  'g-16-3': '4/4 de cancha',
  'g-16-4': 'Penal recibido',
  'g-19-1': 'Se queda con el balón',
  'g-19-2': 'No se queda con el balón',
  'g-20-1': '1/4 de cancha',
  'g-20-2': '2/4 de cancha',
  'g-20-3': '3/4 de cancha',
  'g-20-4': '4/4 de cancha',
  'g-21-1': 'En disputa',
  'g-21-2': 'Sin disputa',
  // *
  'g-21-1-1': '1/4 de cancha',
  'g-21-1-2': '2/4 de cancha',
  'g-21-1-3': '3/4 de cancha',
  'g-21-1-4': '4/4 de cancha',
  'g-26-1': 'Cancha propia',
  'g-26-2': 'Cancha rival',
  'g-27-1': 'Con posesión',
  'g-27-2': 'Sin posesión',
  'g-27-3': 'Provoca falta',
  // pending 1 vs 1 no exitoso defensivo
  'g-33-1': 'Pase corto con el pie acertado',
  'g-33-2': 'Pase corto con el pie no acertado',
  'g-33-3': 'Pase largo con el pie acertado',
  'g-33-4': 'Pase largo con el pie no acertado',
  'g-34-1': 'A destino',
  'g-34-2': 'No a destino',
  'g-35-1': 'A destino',
  'g-35-2': 'No a destino',
  'g-36-1': 'Exitosos',
  'g-36-2': 'No exitosos',
  'g-38-1': 'Corto acertado',
  'g-38-2': 'Corto no acertado',
  'g-38-3': 'Largo acertado',
  'g-38-4': 'Largo no acertado',
  'g-39-1': 'Se queda con el balón',
  'g-39-2': 'No se queda con el balón',
};

export const mainCategoriesByType = (function() {
  const categoriesByType = {
    teamAndPlayer: [
      'g-1',
      'g-2',
      'g-3',
      'g-4',
      'g-5',
      'g-6',
      'g-7',
      'g-8',
      'g-9',
      'g-10',
      'g-11',
      'g-12',
      'g-13',
      'g-14',
      'g-15',
      'g-16',
      'g-17',
      'g-18',
      'g-20',
      'g-21',
      'g-22',
      'g-26',
      'g-27',
      'g-28',
      'g-30',
      'g-31',
      'g-32',
    ],
    team: ['g-23', 'g-24', 'g-25', 'g-29'],
    player: ['g-19'],
    goalkeeper: [
      'g-17',
      'g-18',
      'g-19',
      'g-33',
      'g-34',
      'g-35',
      'g-36',
      'g-37',
      'g-38',
      'g-39',
      'g-40',
      'g-41',
      'g-42',
    ],
  };
  if (categoriesByTypeList === null) {
    categoriesByTypeList = Object.entries(categoriesByType).reduce((accumulator, [k, v]) => {
      accumulator[k] = v.reduce((acc, groupId) => {
        acc.set(groupId, '');
        return acc;
      }, new Map());
      return accumulator;
    }, {});
  }
  return categoriesByTypeList;
})();

export const categoryCoordinate = {
  'g-1': 2,
  'g-2': 3,
  'g-3': 1,
  'g-4': 1,
  'g-5': 2,
  'g-6': 1,
  'g-7': 2,
  'g-8': 2,
  'g-9': 1,
  'g-10': 1,
  'g-11': 1,
  'g-12': 1,
  'g-13': 3,
  'g-14': 3,
  'g-15': 3,
  'g-16': 3,
  'g-17': 1,
  'g-18': 3,
  'g-19': 3,
  'g-20': 3,
  'g-21': 1,
  'g-22': 2,
  'g-23': 2,
  'g-24': 1,
  'g-25': 3,
  'g-26': 1,
  'g-27': 1,
  'g-28': 1,
  'g-29': 1,
  'g-30': 2,
  'g-31': 3,
  'g-32': 3,
  'g-33': 3,
  'g-34': 2,
  'g-35': 2,
  'g-36': 1,
  'g-37': 1,
  'g-38': 3,
  'g-39': 1,
  'g-40': 1,
};
